<template>
    <v-app id="inspire" v-scroll="onScroll" v-cloak>
        <Toolbar></Toolbar>
        <Nav></Nav>
        <br><br>
        <p class="pageInfo hidden-md-and-up">Current Data Set: &nbsp;<span class="current">{{ $store.state.pageName }}</span></p><p style="text-align: center">This page is best viewed on larger screens</p>
        <Rev v-show="$store.state.pageName == 'Revenue Sources'"></Rev>
        <Yearly v-show="$store.state.pageName == 'Yearly Cost Breakdown'"></Yearly>
        <Monthly v-show="$store.state.pageName == 'Cost By Month'"></Monthly>
        <Break v-show="$store.state.pageName == 'Break Even Analysis'"></Break>
        <Opp v-show="$store.state.pageName == 'Opportunity Size'"></Opp>
        <Summary v-show="$store.state.pageName == 'Summary'"></Summary>
        <v-btn
          color="teal lighten-1"
          v-show="offsetTop > 600"
          @click="$vuetify.goTo(0, options)"
          dark
          fixed
          bottom
          right
          fab
        >
          <v-icon x-large>keyboard_arrow_up</v-icon>
        </v-btn>  
        <Instructions v-show="offsetTop < 600"></Instructions>
    </v-app>
</template>

<script>
import Instructions from '@/components/Instructions.vue'
import Toolbar from '@/components/Toolbar.vue'
import Nav from '@/components/Nav.vue'
import Rev from '@/components/Rev.vue'
import Yearly from '@/components/Yearly.vue'
import Monthly from '@/components/Monthly.vue'
import Break from '@/components/Break.vue'
import Opp from '@/components/Opp.vue'
import Summary from '@/components/Summary.vue'

export default {
  name: 'datap',
  data () {
    return {
      duration: 400,
      offset: 0,
      easing: 'easeInOutCubic',
      offsetTop: 0
    }
  },
  methods: {
    onScroll (e) {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
    }
  },
  computed: {
    options () {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing
      }
    }
  },
  components: {
    Toolbar,
    Nav,
    Instructions,
    Rev,
    Yearly,
    Monthly,
    Break,
    Opp,
    Summary
  }
}    
</script>

<style>
[v-cloak] { display:none }
.v-toolbar__title {
  font-family: 'Poppins', sans-serif;
  font-weight: bold;
  color: #444;
  font-size: medium;
}
td:not(.text-xs-right) {
    width: 300px;
}
tbody tr td:first-of-type {
    text-align: left;
}
td.text-xs-right {
    width: 150px;
}
.v-btn__content {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
}
th.column.text-xs-left {
    font-family: 'Poppins', sans-serif;
}
.flex.teal.lighten-2.py-3.text-xs-center.white--text.xs12 {
    font-family: 'Poppins', sans-serif;
}
.v-avatar {
  background: #FF6434
}
p.pageInfo.hidden-md-and-up {
    margin-top: 40px;
}
#inspire {
    background-image: url(https://pawtocol.com/images/bgdata.png) !important;
    background-blend-mode: color;
    background-color: #dcdcdcba;
    background-size: contain;
}
.v-avatar img {
  padding: 5px;
}
th.column.text-xs-left:first-of-type {
    font-weight: 600;
    font-size: 18px;
    color: #15A79D;
}
.v-card__text {
    white-space: pre;
}
p.pageInfo {
    display: flex;
    align-self: center;
    margin: 0;
    justify-self: flex-end;
}
tbody tr:nth-child(4n-7) {
    background: #e6e6e6;
}
tbody tr:nth-last-child(2) {
    font-weight: bold !important;
    pointer-events: none
}
tbody tr:nth-last-child(2) td {
    background: #888c8c  !important;
    font-weight: 400 !important;
    color: #fff;
    font-size: 14px;
}
th.column.text-xs-right {
    font-weight: 800 !important;
}
.bump {
  padding: 20px;
}
.squeeze {
  margin: 0 auto;
  max-width: 100vw;
}
.example {
    margin-bottom: -3px;
}
.elevation-6 {
    border-radius: 6px;
    box-shadow: 0 3px 5px -1px rgba(0,0,0,0),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)!important;
    transition: all .5s;
    overflow: hidden;
}
.elevation-6:hover {
    box-shadow: 0 3px 5px 0px rgba(0,0,0,0),0 6px 10px 0 rgba(0,0,0,.2),0 1px 30px 0 rgba(0,0,0,.3)!important;
}

.v-dialog.v-dialog--active {
    border-radius: 10px;
}
.v-dialog .v-card__text {
    white-space: normal;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.current {
  background: #FF6434;
  color: #fff;
  border-radius: 3px;
  padding: 3px 5px;
  margin-top: -3px
}
.footlocker {
  position: fixed;
  bottom: 0;
  width: 100%;
}
@media (max-width: 959px) {
  .bump {
    padding: 10px 5px 20px;
}
}
</style>